import { Routes, Route, Navigate } from 'react-router-dom'
import { ReactNode } from 'react'
import { useAuth } from '@/hooks/useAuth'
import Login from '@/pages/Login'
import AuthCallback from '@/pages/AuthCallback'
import Home from '@/pages/Home'
import Settings from '@/pages/Settings'
import Reader from '@/pages/Reader'
import BookSettings from '@/pages/BookSettings'
import { getLastBook } from '@/lib/lastBook'

function RequireAuth({ children }: { children: ReactNode }) {
  const { viewer, loading } = useAuth()
  if (loading) return <div className="min-h-screen grid place-items-center text-slate-400">Loading…</div>
  if (!viewer) return <Navigate to="/login" replace />
  return <>{children}</>
}

// Root opens the last book the reader had open; the library lives at /library.
// First-time users (no remembered book) land on the library instead.
function RootRedirect() {
  const last = getLastBook()
  return <Navigate to={last ? `/books/${last}` : '/library'} replace />
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <RootRedirect />
          </RequireAuth>
        }
      />
      <Route
        path="/library"
        element={
          <RequireAuth>
            <Home />
          </RequireAuth>
        }
      />
      <Route
        path="/settings"
        element={
          <RequireAuth>
            <Settings />
          </RequireAuth>
        }
      />
      <Route
        path="/books/:slug"
        element={
          <RequireAuth>
            <Reader />
          </RequireAuth>
        }
      />
      <Route
        path="/books/:slug/settings"
        element={
          <RequireAuth>
            <BookSettings />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
